import * as _ from 'lodash'

function mean (values) {
  return _.mean(values)
}

function stdDev (values) {
  const avg = _.mean(values)
  return Math.sqrt(_.sum(_.map(values, (i) => Math.pow((i - avg), 2))) / values.length)
}

function cv (values) {
  return 100 * stdDev(values) / mean(values)
}

export default {
  mean,
  stdDev,
  cv
}



// WEBPACK FOOTER //
// ./src/lib/math.js